import React from 'react';

type FlagCode = 'GB' | 'ZA';

interface FlagIconProps {
  code: FlagCode;
  size?: number;
  className?: string;
  'aria-label'?: string;
}

/**
 * Inline SVG flags for currency/region display (e.g. exchange rate banner).
 * Country flag icons for GBP (GB) and ZAR (ZA).
 */
export function FlagIcon({ code, size = 16, className, 'aria-label': ariaLabel }: FlagIconProps) {
  const width = size * (4 / 3);

  const svgProps = {
    width,
    height: size,
    className,
    'aria-label': ariaLabel ?? (code === 'GB' ? 'United Kingdom' : 'South Africa'),
  };

  if (code === 'GB') {
    return (
      <svg {...svgProps} viewBox="0 0 12 6">
        <rect width="12" height="6" fill="#012169" />
        <path d="M0,0 12,6 M12,0 0,6" stroke="#fff" strokeWidth="1.2" />
        <path d="M0,0 12,6 M12,0 0,6" stroke="#C8102E" strokeWidth="0.6" />
        <rect x="4.8" width="2.4" height="6" fill="#fff" />
        <rect y="2.4" width="12" height="1.2" fill="#fff" />
        <rect x="5.2" width="1.6" height="6" fill="#C8102E" />
        <rect y="2.6" width="12" height="0.8" fill="#C8102E" />
      </svg>
    );
  }

  if (code === 'ZA') {
    return (
      <svg {...svgProps} viewBox="0 0 12 6">
        <rect width="12" height="6" fill="#de3831" />
        <rect y="3" width="12" height="3" fill="#007a4d" />
        <path d="M0,0 L6.5,3 L0,6 Z" fill="#000" />
        <path d="M0,0 L6,3 L0,6 L1.2,6 L6.8,3 L1.2,0 Z" fill="#ffb915" />
        <path d="M1.2,0 L7.8,3 L1.2,6 L2,6 L8.6,3 L2,0 Z" fill="#fff" />
        <path d="M2,0 L8.6,3 L2,6 L3.2,6 L9.8,3 L3.2,0 Z" fill="#0033a0" />
      </svg>
    );
  }

  return null;
}

export default FlagIcon;
